import { render, staticRenderFns } from "./LanguageSpoken.vue?vue&type=template&id=c921755a"
import script from "./LanguageSpoken.vue?vue&type=script&lang=js"
export * from "./LanguageSpoken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports